"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EllipseSpinner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var bounce = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%, 80%, 100% {transform: scale(0)};\n\t40% {transform: scale(1)};\n"], ["\n  0%, 80%, 100% {transform: scale(0)};\n\t40% {transform: scale(1)};\n"])));
var Ellipse = styled_components_1.default.i(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  animation: ", " 1.4s infinite ease-in-out both;\n"], ["\n  animation: ", " 1.4s infinite ease-in-out both;\n"])), bounce);
var EllipseContainer = styled_components_1.default.i(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 100px auto 0;\n  width: 70px;\n  text-align: center;\n"], ["\n  margin: 100px auto 0;\n  width: 70px;\n  text-align: center;\n"])));
var EllipseSpinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '1em' : _b, _c = _a.color, color = _c === void 0 ? 'blue' : _c;
    var className = "bg-" + color;
    var styles = {
        height: size,
        width: size,
        borderRadius: '100%',
        display: 'inline-block',
    };
    return (jsx_runtime_1.jsxs(EllipseContainer, { children: [jsx_runtime_1.jsx(Ellipse, { className: className, style: __assign({ animationDelay: '-0.32s' }, styles) }, void 0),
            jsx_runtime_1.jsx(Ellipse, { className: className, style: __assign({ animationDelay: '-0.16s' }, styles) }, void 0),
            jsx_runtime_1.jsx(Ellipse, { className: className, style: styles }, void 0)] }, void 0));
};
exports.EllipseSpinner = EllipseSpinner;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=EllipseSpinner.js.map